<div class="app__container container-fluid">
    <div class="row app__background">
        <div class="app__overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <a routerLink="/" [ngClass]="{'app__isDisabled': this.router.url === '/thanks'}">
                        <img src="/assets/logo_claim.svg"   style="min-height: 70px;" class="app__logo img-fluid" />
                    </a>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-12">
                            <h1 class="text-center white">Thank you for your support!</h1>
                            <p *ngIf="firebaseService.donationTargetString" class="text-center white">
                                With your vote you have increased the amount donated to project <strong>{{
                                    firebaseService.donationTargetString }}</strong>!
                                <br><br class="mobile">
                                <strong>Currently, the donation amount is distributed as follows:</strong>
                            </p>
                        </div>
                    </div>

                    <div class="row rating">

                        <div class="col-12 col-lg-4">
                            <div class="card">
                                <div class="rating__check"
                                    *ngIf="firebaseService.donationTarget == DonationTarget.aerzteOhneGrenzen">
                                    <svg-icon src="/assets/check.svg"></svg-icon>
                                </div>
                                <div class="card__image">
                                    <img class="img-fluid max-9 mw-80 w-aog" src="/assets/aerzte-ohne-grenzen.png" />
                                </div>
                                <p class="rating__percentage desktop"></p>
                                <p class="rating__text desktop text-center">{{ firebaseService.statistic.medicinsSFPercent |
                                    number:'1.0-0' }}% of all votes</p>
                                <div class="mobile">
                                    <div class="">
                                        <p class="text-center">Médecins Sans Frontières</p>
                                        <p class="text-center"><br /><span class="fs-small">{{ firebaseService.statistic.medicinsSFPercent | number:'1.0-0' }}% of all votes</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-4">
                            <div class="card">
                                <div class="rating__check"
                                    *ngIf="firebaseService.donationTarget == DonationTarget.unicef">
                                    <svg-icon src="/assets/check.svg"></svg-icon>
                                </div>
                                <div class="card__image">
                                    <img class="img-fluid max-9 mw-80 w-uni" src="/assets/unicef.png" />
                                </div>
                                <p class="rating__percentage desktop"></p>
                                <p class="rating__text desktop text-center">{{ firebaseService.statistic.unicefPercent |
                                    number:'1.0-0' }}% of all votes</p>
                                <div class="mobile">
                                    <div class="">
                                        <p class="text-center">UNICEF</p>
                                        <p class="text-center"><br /><span class="fs-small">{{ firebaseService.statistic.unicefPercent | number:'1.0-0' }}% of all votes</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div class="col-12 col-lg-4">
                            <div class="card">
                                <div class="rating__check"
                                    *ngIf="firebaseService.donationTarget == DonationTarget.frankfurterTafel">
                                    <svg-icon src="/assets/check.svg"></svg-icon>
                                </div>
                                <div class="card__image">
                                    <img class="img-fluid max-9 mw-80 w-ft" src="/assets/frankfurter-tafel.png" />
                                </div>
                                <p class="rating__percentage desktop"></p>
                                <p class="rating__text desktop text-center">{{ firebaseService.statistic.ffmTafelPercent |
                                    number:'1.0-0' }}% of all votes</p>
                                <div class="mobile">
                                    <div class="">
                                        <p class="text-center">Frankfurter Tafel</p>
                                        <p class="text-center"><br /><span class="fs-small">{{ firebaseService.statistic.ffmTafelPercent | number:'1.0-0' }}% of all votes</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 text-center mt-50 mb-5" style="margin-top: 50px;">
                            <img src="/assets/awards-german-design-2021.png" height="50" style="margin-bottom: 20px;" />
                            &nbsp;
                            <img src="/assets/awards-german-design-2022.png" height="50" style="margin-bottom: 20px;" />
                            &nbsp;
                            <img src="/assets/GDA23_HO_SPECIAL_MCN_RGB.png" height="50" style="margin-bottom: 20px;" />
                            &nbsp;
                            <img src="/assets/GDA24_HO_WINNER_MCN_4C.png" height="50" style="margin-bottom: 20px;" />
                            &nbsp;
                            <img src="/assets/GDA25_HO_WINNER_MCN_RGB.png" height="50" style="margin-bottom: 20px;" />
                            &nbsp;
                            <img src="/assets/kununu_top_company_2024.png" height="50" style="margin-bottom: 20px;" />
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <app-footer-en></app-footer-en>
                </div>
            </div>
        </div>

    </div>
</div>
